export default{
    "clinics.detail.cart.items.title"     : "Items Selection",
    "clinics.detail.cart.items.mandatory" : "Mandatory Items",
    "clinics.detail.cart.items.optional"  : "Optional Items",
    "clinics.detail.cart.items.selected"  : "Selected Items",
}